export default {
      id: "long-arrow-left-regular-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#long-arrow-left-regular-usage",
      toString: function () {
        return this.url;
      }
    }